import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d6a692a")

_pushScopeId("data-v-4d6a692a")
const _hoisted_1 = { class: "ExpressCity" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "ExpressCity__title" }, "Выберите город", -1)
const _hoisted_3 = {
  key: 0,
  class: "ExpressCity__state state--loading"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "state--text text--loading" }, "Загрузка списка городов...", -1)
const _hoisted_5 = {
  key: 1,
  class: "ExpressCity__state state--failed"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "state--text text--failed" }, "При загрузке списка городов произошла ошибка", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Перезагрузить")
const _hoisted_8 = { class: "ExpressCity__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_s_switch = _resolveComponent("s-switch")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_s_loader),
                _hoisted_4
              ]))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_s_button, {
                    class: "green",
                    onClick: _ctx.loadCities
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      (_ctx.selectedCity)
        ? (_openBlock(), _createBlock(_component_s_switch, {
            key: 0,
            theme: "blue",
            value: _ctx.selectedCity,
            options: _ctx.state.list,
            disabled: _ctx.disabled,
            onChange: _ctx.setCity
          }, null, 8, ["value", "options", "disabled", "onChange"]))
        : _createCommentVNode("", true)
    ])
  ]))
})